import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
import './FaqSection.css';

const faqs = [
  {
    question: "Are the courses available online or offline?",
    answer: "We offer both online and offline modes for all our courses. You can choose your preferred mode during registration."
  },
  {
    question: "When do new batches start?",
    answer: "New batches begin every 1st and 15th of the month. You’ll be notified via email upon successful registration."
  },
  {
    question: "Can I switch from offline to online later?",
    answer: "Yes, you can switch modes anytime during the course by contacting our support team."
  },
  {
    question: "Do you provide course completion certificates?",
    answer: "Yes, a digital and hard copy certificate is issued after successful completion of the course and final assessment."
  }
];

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section-container">
      <div className="faq-section-wrapper">
        <div className="faq-section-header">
          <HelpCircle className="faq-section-header-icon" />
          <h2 className="faq-section-title">Frequently Asked Questions</h2>
          <p className="faq-section-subtitle">
            Answers to common queries about our courses, schedules, and modes of learning.
          </p>
        </div>
        <div className="faq-section-accordion">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-section-item ${openIndex === index ? 'open' : ''}`}
            >
              <div
                className="faq-section-question"
                onClick={() => toggleFAQ(index)}
              >
                <span>{faq.question}</span>
                {openIndex === index ? (
                  <ChevronUp className="faq-section-toggle-icon" />
                ) : (
                  <ChevronDown className="faq-section-toggle-icon" />
                )}
              </div>
              <div className="faq-section-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
